import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';

const Rules = () => {
    const router = useRouter()

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Правила" 
                labelBtn="Добавить"
                button={() => {
                    router.history.push('/settings/rules/create')
                }}
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                width: 'calc(100% - 40px)', 
            }}>
                1234
            </div>
        </div>
    )
}

export default Rules;